export default "/images/air-monitoring.jpg";